import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { PaymentMethodDto } from 'interfaces/paymentMethods';

interface PaymentMethodsService {
  list(): Promise<PaymentMethodDto[]>;
}

const endpoints = {
  paymentMethods: '/payment-methods',
};

export const paymentMethodsService: PaymentMethodsService = {
  list: async (): Promise<PaymentMethodDto[]> => {
    const response: AxiosResponse<ApiResponseDto<PaymentMethodDto[]>> = await apiClient.get(endpoints.paymentMethods);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
